export const activityStatus = Object.freeze({
	Pending: 0,
	Completed: 1,
	DataReady: 2,
});
